module.exports = __webpack_public_path__ + "static/media/product-Anylocal.0dceee28.png";